import { Injectable } from '@angular/core';
import {FxModalService} from '../components/fx-modal/fx-modal.service';
import {DwModalService} from 'ng-quicksilver';
import {FxVideoCompressModalComponent} from './fx-video-compress-modal/fx-video-compress-modal.component';
import {Observable} from 'rxjs';
import {FxVideoCompressModalLiteComponent} from './fx-video-compress-modal-lite/fx-video-compress-modal-lite.component';
import {DwUserService} from '@webdpt/framework';
import {FxFfmpegUtilService} from './fx-ffmpeg-util.service';

@Injectable({
  providedIn: 'root'
})
export class FxFfmpegModalService {

  constructor(
    public fxModalService: FxModalService,
    public dwModalService: DwModalService,
    private fxUserService: DwUserService,
    private fxffmpegUtilServie: FxFfmpegUtilService
  ) {

  }

  public openModal = (file: any): Observable<any>  => {
    const cs075AsPlan = this.getSystemConfCompressPlan();
    const planName: string = cs075AsPlan === '2'
      ? 'solution-best-filesize'
      : 'solution-best-speed';
    if (cs075AsPlan === '3') {
      return this.openGUI(file, planName);
    } else {
      return this.openProgress(file, planName);
    }
  }

  private openGUI = (file: any, planName: string): Observable<any>  => {
    return Observable.create((observer) => {
      const modal = this.dwModalService.create({
        dwTitle: '视频压缩助手v2',
        dwStyle: {top: '20px'},
        dwMaskClosable: false, // 點擊遮罩是否允許關閉
        dwContent: FxVideoCompressModalComponent,
        dwWrapClassName: 'fx_md_modal',
        dwClosable: false,
        dwFooter: null,
        dwOnOk: (data: any = {}): void => {
          observer.next(data.uploadResponseData);
          observer.complete();
        },
        dwOnCancel: (data: any = {}): void => {
          observer.next(data.uploadResponseData);
          observer.complete();
        },
        dwComponentParams: {
          title: '视频压缩助手',
          inputVideoFile: file,
          planName: planName
        }
      });
    });
  }

  private openProgress = (file: any, planName: string): Observable<any>  => {
    return Observable.create((observer) => {
      const modal = this.dwModalService.create({
        dwTitle: null,
        dwStyle: {top: '30vh', left: '45vw'},
        dwWidth: '10vw',
        // dwCloseOnNavigation: false,
        dwMaskClosable: false, // 點擊遮罩是否允許關閉
        dwContent: FxVideoCompressModalLiteComponent,
        dwWrapClassName: 'fx_md_modal',
        dwClosable: false,
        // dwClassName: className,
        dwFooter: null,
        dwOnOk: (data: any = {}): void => {
          observer.next(data.uploadResponseData);
          observer.complete();
        },
        dwOnCancel: (data: any = {}): void => {
          observer.next(data.uploadResponseData);
          observer.complete();
        },
        dwComponentParams: {
          title: '视频压缩助手',
          inputVideoFile: file,
          planName: planName
        }
      });
    });
  }

  /**
   * 上传视频文件前自动压缩
   * 通过系统参数 c_S074 配置
   * 1. 压缩时间更短，生成的文件较大
   * 2. 压缩时间更长，但生成的文件较小
   */
  public getSystemConfNeedAutoCompress = (): boolean => {
    return this.fxUserService.getSysParamById('c_S074') === 'Y';
  }

  /**
   * 视频自动压缩方案
   * 通过系统参数 c_S075 配置
   * 1. 压缩时间更短，生成的文件较大
   * 2. 压缩时间更长，但生成的文件较小
   * 3. 由用户自定义
   */
  public getSystemConfCompressPlan = (): string => {
    return this.fxUserService.getSysParamById('c_S075') || '1';
  }

  public checkFileTypeSupport = (fileType: string): boolean => {
    return this.fxffmpegUtilServie.checkFileTypeSupport(fileType);
  }
}
